import type { ComponentProps } from "react";

export default function DiscountIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.10856 7.43319C9.10856 6.50907 8.35632 5.75684 7.43221 5.75684C6.5081 5.75684 5.75586 6.50907 5.75586 7.43319C5.75586 8.3573 6.5081 9.10953 7.43221 9.10953C8.35632 9.10953 9.10856 8.3573 9.10856 7.43319ZM6.51776 7.43319C6.51776 6.9302 6.92699 6.51876 7.43219 6.51876C7.93665 6.51876 8.34662 6.92798 8.34662 7.43319C8.34662 7.93765 7.9374 8.34761 7.43219 8.34761C6.92773 8.34761 6.51776 7.93839 6.51776 7.43319Z"
        fill="currentColor"
      />
      <path
        d="M12.567 10.8916C11.6429 10.8916 10.8906 11.6438 10.8906 12.568C10.8906 13.4921 11.6429 14.2443 12.567 14.2443C13.4911 14.2443 14.2433 13.4921 14.2433 12.568C14.2433 11.6438 13.4911 10.8916 12.567 10.8916ZM12.567 13.4824C12.0625 13.4824 11.6525 13.0732 11.6525 12.568C11.6525 12.0635 12.0618 11.6535 12.567 11.6535C13.0714 11.6535 13.4814 12.0628 13.4814 12.568C13.4814 13.0724 13.0722 13.4824 12.567 13.4824Z"
        fill="currentColor"
      />
      <path
        d="M13.0334 6.96708C12.8846 6.81827 12.6428 6.81827 12.4947 6.96708L6.96708 12.4947C6.81827 12.6435 6.81827 12.8853 6.96708 13.0334C7.04148 13.1078 7.1382 13.1457 7.23568 13.1457C7.33316 13.1457 7.42987 13.1078 7.50428 13.0334L13.0319 7.50577C13.1807 7.35696 13.1807 7.11516 13.0319 6.96708H13.0334Z"
        fill="currentColor"
      />
      <path
        d="M10 2C5.58857 2 2 5.58857 2 10C2 14.4114 5.58857 18 10 18C14.4114 18 18 14.4114 18 10C18 5.58857 14.4114 2 10 2ZM10 17.2381C6.00968 17.2381 2.7619 13.9903 2.7619 10C2.7619 6.00968 6.00968 2.7619 10 2.7619C13.9903 2.7619 17.2381 6.00968 17.2381 10C17.2381 13.9903 13.9903 17.2381 10 17.2381Z"
        fill="currentColor"
      />
    </svg>
  );
}
